<template lang="pug">
  v-dialog(
    width="450",
    persistent,
    v-model="isShow")
      Autoincrement(:edit="true", @cancel="isShow=false", v-if="type === 'autoIncrement'")
      TextField(:edit="true" :editField="field" @edit-cancel="isShow=false" @edit-field="editField" v-if="type === 'text' || type === 'number'")
      TextAreaField(:edit="true" :editField="field" @edit-cancel="isShow=false" @edit-field="editField" v-if="type === 'textArea'")
      SelectField(:edit="true" :editField="field" @edit-cancel="isShow=false" @edit-field="editField" v-if="type === 'select'")
      CheckboxField(:edit="true" :editField="field" @edit-cancel="isShow=false" @edit-field="editField" v-if="type === 'checkbox'")
      RadioButtonField(:edit="true" :editField="field" @edit-cancel="isShow=false" @edit-field="editField" v-if="type === 'radio'")
      DateField(:edit="true" :editField="field" @edit-cancel="isShow=false" @edit-field="editField" v-if="type === 'date'")
      TyndykField(:edit="true" :editField="field" @edit-cancel="isShow=false" @edit-field="editField" v-if="type === 'tyndyk'")
      Map(:edit="true" :editField="field" @cancel="isShow=false" @edit-field="editField" v-if="type === 'map'")
</template>
<script>
import TyndykField from '@/components/Constructor/components/TyndykField'
import TextField from '@/components/Constructor/components/TextField'
import TextAreaField from '@/components/Constructor/components/TextAreaField'
import SelectField from '@/components/Constructor/components/SelectField'
import CheckboxField from '@/components/Constructor/components/CheckboxField'
import RadioButtonField from '@/components/Constructor/components/RadioButtonField'
import DateField from '@/components/Constructor/components/DateField'
import Autoincrement from './components/Autoincrement'
import ImageUpload from './components/ImageUpload'
import Map from './components/Map'
export default {
  components: {
    Map,
    ImageUpload,
    Autoincrement,
    TyndykField,
    TextField,
    TextAreaField,
    SelectField,
    CheckboxField,
    RadioButtonField,
    DateField
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    field: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    type: ''
  }),
  watch: {
    field(val) {
      if (val.model) this.type = val.model.split('-')[0]
    }
  },
  computed: {
    isShow: {
      set(val) {
        if (!val) {
          this.$emit('close-edit')
          this.type = ''
        }
      },
      get() {
        return this.show
      }
    }
  },
  methods: {
    editField(data) {
      Object.assign(this.field, data)
      this.isShow = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Constructor/EditField.vue